import {
  AfterViewInit,
  ChangeDetectionStrategy, 
  Component, 
  Input,
  Output,
  OnChanges, 
  ViewEncapsulation,
  EventEmitter
} from '@angular/core';
import { ICardSelf } from '@knz/util';
 

@Component({
  selector: 'card-sub',
  exportAs: 'cardSub',
  templateUrl: './card-sub.component.html',
  host: { '[class.card-sub]': 'true' },
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CardSubComponent implements AfterViewInit, OnChanges {
  @Input() number: number = 1;
  @Input() data: ICardSelf = {}; 
  @Input() type: string = "";
  @Output() itemClickEvent = new EventEmitter<any>();

  get rowNumber() {
    if (this.number >= 10) {
      return this.number;
    } else if (this.number >= 1 && this.number < 10) {
      return "0" + this.number;
    } else {
      return "01";
    }
  }

  get photo(){
    let result="";
    if(this.data!=undefined && this.data.photo!=undefined && this.data.photo!=null && this.data.photo!=""){
      result= this.data.photo;
    }
    return result;
  }
  constructor() {}
 

  ngAfterViewInit() { 
  }

  ngOnChanges() { 
  }
 
  
  cardClick() { 
    this.itemClickEvent.emit(this.data);
  }
}
